import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

const GroupsActions = ({ disabled, removeUser, removeGroup, parentUrl }) => {
  const handler = removeUser || removeGroup || undefined;
  const text = removeUser ? "Remove user" : "Remove group";
  return (
    <div className="l-groups__footer" style={{ gridArea: "footer" }}>
      {handler ? (
        <div className="l-flex-spaced-centered">
          <button
            className="u-no-margin--bottom"
            type="button"
            onClick={handler}
            disabled={disabled}
          >
            {text}
          </button>

          <Link to={parentUrl} className="p-button u-no-margin--bottom">
            Close
          </Link>
        </div>
      ) : (
        <div className="l-flex-end-centered">
          <Link to={parentUrl} className="p-button u-no-margin--bottom">
            Close
          </Link>
        </div>
      )}
    </div>
  );
};

GroupsActions.propTypes = {
  disabled: PropTypes.bool.isRequired,
  removeUser: PropTypes.func,
  removeGroup: PropTypes.func,
  parentUrl: PropTypes.string.isRequired
};

GroupsActions.defaultProps = {
  removeUser: undefined,
  removeGroup: undefined
};

export default GroupsActions;
